import {newE2EPage} from '@stencil/core/testing';
import {createPage} from '@/tests/utils';

function delay(time: number) {
    return new Promise(function (resolve) {
        setTimeout(resolve, time);
    });
}

describe('snackbar e2e', () => {
    it('renders a snackbar with a custom CTA able to trigger any action', async () => {
        const page = await newE2EPage();
        await page.setContent('<joy-snackbar level="error" action-text="Click me if you can"></joy-snackbar>');

        const triggerActionElement = await page.find('joy-snackbar >>> .joy-snackbar__trigger___action');

        expect(triggerActionElement).not.toBe(null);
        expect(triggerActionElement.textContent).toBe('Click me if you can');
    });

    it('should destroy the snackbar when clicking on the cross icon', async () => {
        const page = await createPage();
        await page.setContent('<joy-snackbar level="error" closable="true" duration="forever"></joy-snackbar>');

        await page.evaluate(() => {
            (document.querySelector('joy-snackbar')!.shadowRoot!.querySelector('.joy-snackbar__close-icon') as HTMLJoyIconElement)!.click();
        });

        await delay(600);
        await page.waitForChanges();

        const snackbar = await page.find('joy-snackbar');
        expect(snackbar).toBeNull();
    });

    it('should not be able to close the snackbar', async () => {
        const page = await newE2EPage();
        await page.setContent('<joy-snackbar level="error" closable="false"></joy-snackbar>');

        const close = await page.find('joy-snackbar >>> .joy-snackbar__close-icon');
        expect(close).toBe(null);
    });
});
